import React from 'react';
import image from '../../../images/candevice.png';
import SettingsIcon from '@mui/icons-material/Settings';
import { CircularProgressbar } from 'react-circular-progressbar';
import { useMutation, useQuery } from 'react-query';
import useStore, { updateDeviceActivities } from '../../../Store/Store';
import { ceil, find, isEmpty } from 'lodash';
import { findMyDevice, getDevices, getUserDevices, getWalkActivity } from '../../../utils/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useTheme, useMediaQuery, Box } from '@mui/material';
import SelectInput from '../../../components/SelectInput';
import { useTranslation } from 'react-i18next';
const Progress = ({ total, value }) => {
  return (
    <CircularProgressbar
      value={value}
      maxValue={total}
      circleRatio={0.8}
      styles={{
        root: {},
        path: {
          stroke: `#8cd03b`,
          strokeLinecap: 'butt',
          transition: 'stroke-dashoffset 0.5s ease 0s',
          transform: 'rotate(0.6turn)',
          transformOrigin: 'center center',
          strokeWidth: 4,
        },
        trail: {
          stroke: 'grey',
          strokeLinecap: 'butt',
          transform: 'rotate(0.60turn)',
          transformOrigin: 'center center',
          strokeWidth: 4,
          strokeOpacity: '0.3',
        },
      }}
    />
  );
};

export default function DeviceCard() {
  const { t } = useTranslation();
  const history = useNavigate();
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const [activityGoal, setActivityGoal] = React.useState({ goals: '--', activity: '--' });
  const [activeDevice, setActiveDevice] = React.useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const { data, isLoading } = useQuery(
    ['getDevices', 'getUserDevices', selectedRecipient],
    () => {
      if (isEmpty(selectedRecipient)) {
        return getDevices({ userId: user?._id || user?.id });
      } else {
        return getUserDevices({ userId: user?._id || user?.id, selectedRecipient });
      }
    },
    {
      onSuccess: ({ data }) => {
        if (!isEmpty(data)) {
          setActiveDevice(data[0]);
        }
      },
      retry: false,
      cacheTime: 0,
    },
  );

  const { isLoading: loader } = useQuery(
    ['getWalkActivity', data, selectedRecipient],
    () =>
      getWalkActivity({
        userId: isEmpty(selectedRecipient) ? user?._id : selectedRecipient,
        deviceId: activeDevice?._id,
      }),
    {
      retry: false,
      onSuccess: ({ data }) => {
        let activityMins = data?.ACTIVE_MINUTES;
        let steps = data?.STEPS;
        let distance = data?.DISTANCE_TRAVELED;
        updateDeviceActivities({ activityMins, steps, distance });
        const goals = user?.goal?.daily?.at(-1)?.value || 30;
        setActivityGoal({
          goals,
          activity: activityMins,
        });
      },
      onError: (error) => {
        setActivityGoal({ goals: '--', activity: '--' });
        console.log('error =====> ', error);
      },
    },
  );

  const findDevice = useMutation(findMyDevice, {
    onSuccess: (data) => {
      toast(data?.results || 'Your CANgo should peep and vibrate now');
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleFindDevice = () => {
    findDevice.mutate({ userId: user?._id, deviceId: activeDevice?._id });
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: isMobile ? 'auto' : '352px',
        padding: isMobile ? '16px' : '24px',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        flexWrap: 'nowrap',
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        position: 'relative',
        overflow: 'hidden',
        marginLeft: width > 550 ? '10px' : '0px',
        marginBottom: isMobile ? '16px' : '0px',
      }}
      className="main-container top-margin-card"
    >
      <div
        style={{
          display: 'flex',
          minWidth: '0',
          justifyContent: 'space-between',
          alignItems: 'center',
          alignSelf: 'stretch',
          flexShrink: '0',
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          position: 'relative',
          gap: isMobile ? '16px' : '0px',
        }}
      >
        {/* <span
          style={{
            height: '28px',
            flexShrink: '0',
            flexBasis: 'auto',
            fontFamily: 'Roboto, var(--default-font-family)',
            fontSize: isMobile ? '18px' : '20px',
            fontWeight: '500',
            lineHeight: '28px',
            color: '#1d1d1f',
            position: 'relative',
            textAlign: 'left',
            whiteSpace: 'nowrap',
            zIndex: '1',
          }}
        >
          CAN Go
        </span> */}
        {!isEmpty(data?.data) && (
          <Box style={{ marginBottom: '10px' }}>
            <SelectInput
              options={data?.data?.map((device) => device?.name)}
              value={activeDevice?.name || data?.data[0]?.name}
              onChange={(e) => {
                const { value } = e.target;
                const deviceData = find(data?.data || [], (i) => i.name === value);
                setActiveDevice(deviceData);
              }}
            />
          </Box>
        )}
        {!isEmpty(activeDevice?._id) && (
          <div
            style={{
              display: 'flex',
              width: isMobile ? '100%' : '127px',
              gap: '8px',
              alignItems: 'center',
              justifyContent: isMobile ? 'flex-start' : 'flex-end',
              flexShrink: '0',
              flexWrap: 'nowrap',
              position: 'relative',
              zIndex: '2',
            }}
          >
            <button
              style={{
                display: 'flex',
                width: isMobile ? '100%' : '87px',
                height: '32px',
                padding: '8px 12px',
                gap: '4px',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: '0',
                flexWrap: 'nowrap',
                backgroundColor: '#00796b',
                borderRadius: '100px',
                border: 'none',
                position: 'relative',
                zIndex: '3',
                cursor: 'pointer',
              }}
              onClick={handleFindDevice}
            >
              <span
                style={{
                  height: '22px',
                  flexShrink: '0',
                  flexBasis: 'auto',
                  fontFamily: 'Roboto, var(--default-font-family)',
                  fontSize: '14px',
                  fontWeight: '500',
                  lineHeight: '22px',
                  color: '#ffffff',
                  position: 'relative',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  zIndex: '4',
                }}
              >
                Find Cane
              </span>
            </button>
            <div
              style={{
                display: 'flex',
                width: '32px',
                height: '32px',
                padding: '8px',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: '0',
                borderRadius: '100px',
                border: '1px solid #e5e5ea',
                position: 'relative',
                zIndex: '5',
              }}
            >
              <div
                style={{
                  width: '16px',
                  height: '16px',
                  flexShrink: '0',
                  position: 'relative',
                  zIndex: '6',
                  cursor: 'pointer',
                }}
                onClick={() => history('/edit-profile?tab=Integrations&openModal=true')}
              >
                <SettingsIcon fontSize="15px" />
              </div>
            </div>
          </div>
        )}
        {isEmpty(data?.data[0]?._id) && (
          <div
            style={{
              display: 'flex',
              width: isMobile ? '100%' : '127px',
              gap: '8px',
              alignItems: 'center',
              justifyContent: isMobile ? 'flex-start' : 'flex-end',
              flexShrink: '0',
              flexWrap: 'nowrap',
              position: 'relative',
              zIndex: '2',
            }}
          >
            <button
              style={{
                display: 'flex',
                width: isMobile ? '100%' : '120px',
                height: '32px',
                padding: '8px 12px',
                gap: '4px',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: '0',
                flexWrap: 'nowrap',
                backgroundColor: '#00796b',
                borderRadius: '100px',
                border: 'none',
                position: 'relative',
                zIndex: '3',
                cursor: 'pointer',
              }}
              onClick={() => history('/edit-profile?tab=Integrations&openModal=true')}
            >
              <span
                style={{
                  height: '22px',
                  flexShrink: '0',
                  flexBasis: 'auto',
                  fontFamily: 'Roboto, var(--default-font-family)',
                  fontSize: '14px',
                  fontWeight: '500',
                  lineHeight: '22px',
                  color: '#ffffff',
                  position: 'relative',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  zIndex: '4',
                }}
              >
                {t('connectDevice')}
              </span>
            </button>
          </div>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          gap: isMobile ? '24px' : '0px',
          marginTop: isMobile ? '24px' : '0px',
        }}
      >
        {(width > 1270 || width < 960) && (
          <div style={{ width: isMobile ? '100%' : 'auto', textAlign: isMobile ? 'center' : 'left' }}>
            <img
              className="can-image-device-card"
              src={image}
              alt="can-device"
              style={{
                maxWidth: isMobile ? '80%' : '100%',
                height: 'auto',
              }}
            />
          </div>
        )}
        <div style={{ alignSelf: 'center', width: isMobile ? '100%' : 'auto' }}>
          <div className="frame-67">
            <div className="frame-68" style={{ textAlign: isMobile ? 'center' : 'left' }}>
              <Progress total={activityGoal?.goals || 0} value={activityGoal?.activity || 0} />
              <button className="tags-69">
                {!isEmpty(data?.data[0]?._id) ? (
                  <span className="daily-activity-goal">Daily activity goal</span>
                ) : (
                  <span>{t('connectCanGoToTrackActivity')}</span>
                )}
              </button>
              <div className="group-6a" />
              <div className="frame-6b">
                <div className="slash">
                  <span className="number-10">{activityGoal?.activity || '--'}</span>
                  <span className="slash-6c">/{activityGoal?.goals || '--'}</span>
                </div>
                <span className="minutes">{t('minutes')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
